export enum insProcessCarStep {
  /** 車主資料 */
  InsureProcessVehicleOwnerInfo = 1,
  /** 車籍資料 */
  InsureProcessVehicalInfo = 2,
  /** 選擇商品 */
  InsureProcessSelect = 3,
  /** 填寫資料 */
  InsureProcessFill = 4,
  /** 資料預覽 */
  InsureProcessPreview = 5,
  /** 驗證 OTP 驗證碼 */
  InsureProcessVerifyOTP = 6,
  /** 確認付款 */
  InsureProcessPayment = 7,
  /** 成功投保 */
  InsureProcessSuccess = 8
}

export enum insProcessCarStepIcon {
  /** 車籍資料 (汽車) icon */
  carIcon = 'car',
  /** 車籍資料 (機車) icon */
  motoIcon = 'moto',
  /** 選擇商品 icon */
  selectIcon = 'select',
  /** 填寫資料 icon */
  fillIcon = 'fill',
  /** 資料預覽 icon */
  previewIcon = 'preview',
  /** 確認付款 icon */
  paymentIcon = 'payment',
  /** 成功投保 icon */
  successIcon = 'success'
}
